import { createContext, useContext, useState, useCallback } from 'react';

const CartContext = createContext(null);

export function CartProvider({ children }) {
  const [cartItem,    setCartItem]    = useState(null);   // Cherrypkd = single-item checkout
  const [checkoutData,setCheckoutData] = useState({});

  const addToCart = useCallback((listing, extras = {}) => {
    setCartItem({ listing, ...extras, addedAt: Date.now() });
  }, []);

  const clearCart = useCallback(() => {
    setCartItem(null);
    setCheckoutData({});
  }, []);

  const setCheckout = useCallback((data) => {
    setCheckoutData(prev => ({ ...prev, ...data }));
  }, []);

  return (
    <CartContext.Provider value={{ cartItem, checkoutData, addToCart, clearCart, setCheckout }}>
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => {
  const ctx = useContext(CartContext);
  if (!ctx) throw new Error('useCart must be inside CartProvider');
  return ctx;
};
